export default {
  history: '最近7天记录',
  refreshTime: '最新刷新时间: ',
  status: '状态',
  tunnelMachine: '通道机',
  updateTime: '最新更新时间',
  success: '成功',
  apiType: 'API类型',
  failCount: '失败次数',
  store: '门店',
  StoreOrTunnel: '门店/通道机',
  tunnelReportTitle: '通道机状态报告',
  tunnelMachineId: '通道机编号',
  statusCode: '通道机状态码',
  description: '通道机信息',
  time: '时间',
  timeDate: '时间',
  apiReportTitle: 'API状态报告',
  api: 'API',
  apiStatus: 'API状态',
  errorCode: '错误代码',
  errorMessage: '错误信息',
  messageId: '信息编号',
  payload: 'Payload',
  plant: '仓库编号'
}
